import Image from 'next/legacy/image';

import Corks from '@/app/[locale]/wallet/components/commons/Corks';
import { Link } from '@/i18n/routing';

interface Props {
  id: string;
  title: string;
  price: number;
  loyaltyPointsPrice: number;
  image: string;
}

export default function ExperienceItem(props: Props) {
  return (
    <Link
      href={{
        pathname: '/experience/experience-detail/[id]',
        params: { id: props.id },
      }}
    >
      <li key={props.id} className="text-base w-72 shrink-0 ">
        <div className="relative h-48 w-48 rounded-md overflow-hidden">
          <Image src={props.image} layout="fill" style={{objectFit: 'cover'}} />
        </div>

        <div className="space-y-1 mt-3">
          <h3 className="text-base font-semibold tracking-tight text-greyscale-title mb-0">
            {props.title}
          </h3>

          <div className="flex">
            <span className="font-medium mr-1 text-greyscale-body">
              {props.price.toFixed(2).replace('.', ',')}€
            </span>
            <div className="mr-1">/</div>
            <Corks
              loyaltyPoints={props.loyaltyPointsPrice}
              corkSize="4"
              numberSize="base"
              numberWeight="medium"
              corkColor="primary"
              numberColor="primary"
            />
          </div>
        </div>
      </li>
    </Link>
  );
}
